



import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import {
  getChatUsersApi,
  getChatGroupsApi,
  getEmployeesApi,
  FILE_BASE_URL
} from "../../app/api";
 
import ChatWindow from "./ChatWindow";
import CreateGroupModal from "./CreateGroupModal";
import GroupMembersModal from "./GroupMembersModal";
import { getSocket } from "../../socket/socket";
import { useCallStore } from "../../app/callStore";
 
const IMAGE_BASE_URL = FILE_BASE_URL;
 
export default function ChatDrawer({ employees, onClose }) {
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groups, setGroups] = useState([]);
  const [chatUsersList, setChatUsersList] = useState([]);
  const { activeGroupCalls } = useCallStore();
  const [allEmployees, setAllEmployees] = useState(employees || []);
  const [showCreateGroup, setShowCreateGroup] = useState(false);
  const [inspectGroup, setInspectGroup] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
 
 
 
 
  const [onlineUsers, setOnlineUsers] = useState([]);
 
 
 
 
  const searchRef = useRef(null);
 
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = [1, 2, 3].includes(currentUser.role_id);
 
  // ================= SOCKET (UNREAD COUNT) =================
  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;
 
 
    // 🔥 get initial online users
socket.on("online_users", (users) => {
  setOnlineUsers(users);
});
 
// 🟢 user came online
socket.on("user_online", ({ userId }) => {
  // setOnlineUsers((prev) => [...new Set([...prev, userId])]);
  setOnlineUsers((prev) =>
  prev.includes(userId) ? prev : [...prev, userId]
);
});
 
// 🔴 user went offline
socket.on("user_offline", ({ userId }) => {
  setOnlineUsers((prev) => prev.filter((id) => id !== userId));
});
 
 
 
 
 
    const handleRecv = (data) => {
      // Update user unread
      setChatUsersList((prev) =>
        prev.map((u) =>
          u.id === data.senderId && selectedUser?.id !== data.senderId
            ? {
                ...u,
                unread_count: (u.unread_count || 0) + 1,
                last_message_time: data.createdAt,
              }
            : u
        )
      );
 
      // Update group unread
      if (data.groupId) {
        setGroups((prev) =>
          prev.map((g) =>
            g.id === data.groupId && selectedGroup?.id !== data.groupId
              ? { ...g, unread_count: (g.unread_count || 0) + 1, last_message_time: data.createdAt }
              : g
          )
        );
      }
    };
 
    socket.on("receive_message", handleRecv);
 
    // return () => {
    //   socket.off("receive_message", handleRecv);
    // };
 
      // ================= CLEANUP =================
  return () => {
    socket.off("online_users");
    socket.off("user_online");
    socket.off("user_offline");
    socket.off("receive_message", handleRecv);
  };
  }, [selectedUser?.id, selectedGroup?.id]);
 
  // ================= FETCH GROUPS =================
  const fetchGroups = async () => {
    try {
      const res = await getChatGroupsApi();
      if (res?.success) {
        setGroups(res.groups || []);
      }
    } catch (err) {
      console.error("Failed to fetch groups", err);
    }
  };
 
  // ================= FETCH USERS =================
  const fetchChatUsers = async () => {
    try {
      const res = await getChatUsersApi();
      if (res?.success) {
        setChatUsersList(res.users || res.data || []);
      }
    } catch (err) {
      console.error("Failed to fetch users", err);
    }
  };
 
  const fetchSearchResults = async (query) => {
    try {
      if (!query.trim()) {
        setSearchResults([]);
        setIsSearching(false);
        return;
      }
      setIsSearching(true);
      const res = await getChatUsersApi(query);
      if (res?.success) {
        setSearchResults(res.users || res.data || []);
      }
    } catch (err) {
      console.error("Failed to search users", err);
    }
  };
 
  // Load groups and employees on mount (we only want users with chat history)
  useEffect(() => {
    fetchGroups();
    fetchChatUsers();
   
    // Fallback: If employees weren't passed, fetch all for the Create Group modal
    if (!employees || employees.length === 0) {
      getEmployeesApi().then(res => {
        if (res?.success) {
          setAllEmployees(res.data || res.users || []);
        }
      });
    } else {
      setAllEmployees(employees);
    }
  }, [employees]);
 
  // Search debounce
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchSearchResults(searchQuery);
    }, 300);
    return () => clearTimeout(handler);
  }, [searchQuery]);
 
  // Close dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setIsSearching(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  // Reset unread count locally on open
  useEffect(() => {
    if (selectedUser) {
      setChatUsersList(prev => prev.map(u =>
        u.id === selectedUser.id ? { ...u, unread_count: 0 } : u
      ));
    }
  }, [selectedUser]);
 
  useEffect(() => {
    if (selectedGroup) {
      setGroups(prev => prev.map(g =>
        g.id === selectedGroup.id ? { ...g, unread_count: 0 } : g
      ));
    }
  }, [selectedGroup]);
 
 
  // ================= COMBINE & SORT =================
  const combinedChats = [
    ...groups.map(g => ({ ...g, isGroup: true })),
    ...chatUsersList.map(u => ({ ...u, isGroup: false }))
  ].sort((a, b) => {
    const timeA = new Date(a.last_message_time || a.created_at || 0).getTime();
    const timeB = new Date(b.last_message_time || b.created_at || 0).getTime();
    return timeB - timeA;
  });
 
 
 
  // useEffect(() => {
  //   const userId = window.__OPEN_CHAT_USER_ID__;
 
  //   if (userId && chatUsersList.length > 0) {
  //     const user = chatUsersList.find(u => u.id === userId);
 
  //     if (user) {
  //       setSelectedUser(user);
 
  //       // clear after use
  //       window.__OPEN_CHAT_USER_ID__ = null;
  //     }
  //   }
  // }, [chatUsersList]);
 


  useEffect(() => {
    // 🔔 from notification (localStorage)
    const data = JSON.parse(localStorage.getItem("openChatFromNotification"));
  
    let userId = null;
  
    if (data?.userId) {
      userId = data.userId;
      localStorage.removeItem("openChatFromNotification");
    } else {
      // fallback (existing logic)
      userId = window.__OPEN_CHAT_USER_ID__;
      window.__OPEN_CHAT_USER_ID__ = null;
    }
  
    if (userId && chatUsersList.length > 0) {
      const user = chatUsersList.find(u => u.id === userId);
  
      if (user) {
        setSelectedUser(user);
        setSelectedGroup(null); // 👈 important
      }
    }
  }, [chatUsersList]);




  const formatChatTime = (date) => {
    if (!date) return "";
  
    const d = new Date(date);
    const now = new Date();
  
    const isToday = d.toDateString() === now.toDateString();
  
    if (isToday) {
      // show time
      return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    } else {
      // show date
      return d.toLocaleDateString([], { day: "2-digit", month: "short" });
    }
  };


  return createPortal(
    <div className="fixed inset-0 z-[9999] flex justify-end">
 
      {/* BACKDROP */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/50 backdrop-blur-md"
      />
 
      {/* DRAWER */}
      <div className="relative w-[420px] max-w-[95%] h-full flex flex-col bg-[#1e1e2d] shadow-2xl border-l border-white/20 text-white">
 
        {/* HEADER */}
        <div className="flex justify-between items-center p-4 border-b border-white/10 bg-gradient-to-r from-[#2d1c6a] to-[#24155a]">
          <h3 className="text-lg font-semibold tracking-wide ml-2 flex items-center gap-2">
            Team Chat
          </h3>
 
          <div className="flex items-center gap-3">
            {isAdmin && (
              <button
                onClick={() => setShowCreateGroup(true)}
                title="Create Group"
                className="w-8 h-8 rounded-md bg-white/20 hover:bg-white/30 flex items-center justify-center transition border border-white/10"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                  <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                </svg>
              </button>
            )}
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition"
            >
              ✕
            </button>
          </div>
        </div>
 
        {/* SEARCH BAR */}
        {!selectedUser && !selectedGroup && (
          <div className="p-4 border-b border-white/10 bg-black/20 relative z-50">
            <div className="relative" ref={searchRef}>
              <input
                type="text"
                placeholder="Search users to start a chat..."
                value={searchQuery}
                onFocus={() => setIsSearching(searchQuery.trim().length > 0)}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setIsSearching(e.target.value.trim().length > 0);
                }}
                className="w-full bg-white/5 text-white text-sm rounded-lg pl-10 pr-10 py-2.5 outline-none border border-white/10 focus:border-purple-500 placeholder:text-gray-400 transition"
              />
              <svg
                className="absolute left-3 top-2.5 text-gray-400 w-5 h-5 pointer-events-none"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
 
              {searchQuery && (
                <button
                  onClick={() => {
                    setSearchQuery("");
                    setIsSearching(false);
                    fetchSearchResults("");
                  }}
                  className="absolute right-3 top-2.5 text-gray-400 hover:text-white transition"
                >
                  ✕
                </button>
              )}
 
              {/* DROPDOWN */}
              {isSearching && (
                <div className="absolute top-full left-0 w-full mt-2 bg-[#1e1e2d] border border-white/10 rounded-xl shadow-2xl max-h-64 overflow-y-auto custom-scrollbar z-[10000]">
                  {searchResults.length === 0 ? (
                    <div className="p-4 text-center text-gray-400 text-sm">No users found</div>
                  ) : (
                    searchResults.map(u => (
                      <div
                        key={u.id}
                        onClick={() => {
                          setSelectedUser(u);
                          setIsSearching(false);
                          setSearchQuery("");
                        }}
                        className="flex items-center gap-3 p-3 hover:bg-white/10 cursor-pointer border-b border-white/5 last:border-0"
                      >
                        <div className="w-8 h-8 rounded-full overflow-hidden bg-white/20">
                          {u.profile_pic ? (
                            <img src={`${IMAGE_BASE_URL}${u.profile_pic}`} alt="profile" className="w-full h-full object-cover"/>
                          ) : (
                            <div className="w-full h-full flex items-center justify-center bg-purple-500 text-white font-semibold text-xs">
                              {u.first_name?.charAt(0)}
                            </div>
                          )}
                        </div>
                        <div>
                          <p className="text-sm font-medium">{u.first_name} {u.last_name}</p>
                          {/* <p className="text-[10px] text-gray-400">{u.email}</p> */}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
        )}
 
        {/* BODY */}
        <div className="flex-1 overflow-y-auto p-2 flex flex-col custom-scrollbar">
 
          {selectedUser || selectedGroup ? (
            <ChatWindow
              user={selectedUser}
              group={selectedGroup}
              currentUser={currentUser}
              onBack={() => {
                setSelectedUser(null);
                setSelectedGroup(null);
                // Refresh list on back to get updated times/unread
                fetchGroups();
                fetchChatUsers();
              }}
              onInspectGroup={() => setInspectGroup(selectedGroup)}
              onGroupDeleted={() => {
                setSelectedGroup(null);
                fetchGroups();
              }}
            />
          ) : (
            <div className="flex flex-col gap-1 pb-10">
             
              {combinedChats.map(item => {
                if (item.isGroup) {
                  return (
                    <div
                      key={`g_${item.id}`}
                      onClick={() => setSelectedGroup(item)}
                      className="flex items-center gap-3 p-3 hover:bg-white/10 rounded-xl cursor-pointer transition mb-1 border border-transparent hover:border-white/5"
                    >
                      <div className="w-12 h-12 rounded-full bg-purple-600/50 flex items-center justify-center font-bold text-white shadow-lg overflow-hidden border border-purple-400/30">
                        {item.name.charAt(0).toUpperCase()}
                      </div>
 
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <p className="font-medium text-[15px]">{item.name}</p>
                          {activeGroupCalls.some(c => c.groupId === item.id) && (
                            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse shadow-[0_0_8px_rgba(34,197,94,0.6)]"></span>
                          )}
                        </div>
                        <p className="text-xs text-gray-400 mt-0.5">
                          {activeGroupCalls.some(c => c.groupId === item.id) ? "Active Call" : "Group"}
                        </p>
                      </div>
 
                      {item.unread_count > 0 && (
                        <div className="bg-red-500 w-5 h-5 flex items-center justify-center text-[10px] font-bold rounded-full text-white shadow">
                          {item.unread_count}
                        </div>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={`u_${item.id}`}
                      onClick={() => setSelectedUser(item)}
                      className="flex items-center gap-3 p-3 hover:bg-white/10 rounded-xl cursor-pointer transition mb-1 border border-transparent hover:border-white/5"
                    >
                      {/* <div className="w-12 h-12 rounded-full overflow-hidden bg-white/20 shadow-lg border border-white/10">
                        {item.profile_pic ? (
                          <img
                            src={`${IMAGE_BASE_URL}${item.profile_pic}`}
                            alt="profile"
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center bg-[#2b195c] text-white font-bold opacity-90">
                            {item.first_name?.charAt(0)}
                          </div>
                        )}
                      </div> */}
 
<div className="relative w-12 h-12">
  <div className="w-12 h-12 rounded-full overflow-hidden bg-white/20">
    {item.profile_pic ? (
      <img
        src={`${IMAGE_BASE_URL}${item.profile_pic}`}
        alt="profile"
        className="w-full h-full object-cover"
      />
    ) : (
      <div className="w-full h-full flex items-center justify-center bg-[#2b195c] text-white font-bold">
        {item.first_name?.charAt(0)}
      </div>
    )}
  </div>
 
  {/* 🟢 Teams-style ONLINE DOT */}
  {onlineUsers.includes(item.id) && (
    <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white shadow-sm"></span>
  )}
</div>
 
                      {/* <div className="flex-1">
                        <p className="font-medium text-[15px]">
                          {item.first_name} {item.last_name}
                        </p>
                      </div>
  */}



<div className="flex-1 flex justify-between items-center">
  <div>
    <p className="font-medium text-[15px]">
      {item.first_name} {item.last_name}
    </p>
  </div>

  <span className="text-xs text-gray-400">
    {formatChatTime(item.last_message_time || item.created_at)}
  </span>
</div>





                      {item.unread_count > 0 && (
                        <div className="w-5 h-5 rounded-full bg-red-500 flex items-center justify-center text-[10px] font-bold text-white shadow">
                          {item.unread_count}
                        </div>
                      )}
                    </div>
                  );
                }
              })}
 
              {combinedChats.length === 0 && (
                 <p className="text-center text-sm text-gray-400 mt-10">No chats found. Use the search bar above to start a conversation.</p>
              )}
 
            </div>
          )}
        </div>
 
        {/* MODALS */}
        {showCreateGroup && (
          <CreateGroupModal
            employees={allEmployees}
            onClose={() => setShowCreateGroup(false)}
            onGroupCreated={fetchGroups}
          />
        )}
 
        {inspectGroup && (
          <GroupMembersModal
            group={inspectGroup}
            onClose={() => setInspectGroup(null)}
            employees={allEmployees}
            isAdmin={isAdmin}
          />
        )}
      </div>
    </div>,
    document.body
  );
}




// import { useState, useEffect, useRef } from "react";
// import { createPortal } from "react-dom";
// import {
//   getChatUsersApi,
//   getChatGroupsApi,
//   getEmployeesApi
// } from "../../app/api";

// import ChatWindow from "./ChatWindow";
// import CreateGroupModal from "./CreateGroupModal";
// import GroupMembersModal from "./GroupMembersModal";
// import { getSocket } from "../../socket/socket";

// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

// export default function ChatDrawer({ employees, onClose }) {
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [groups, setGroups] = useState([]);
//   const [chatUsersList, setChatUsersList] = useState([]);
//   const [allEmployees, setAllEmployees] = useState(employees || []);
//   const [showCreateGroup, setShowCreateGroup] = useState(false);
//   const [inspectGroup, setInspectGroup] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [isSearching, setIsSearching] = useState(false);




//   const [onlineUsers, setOnlineUsers] = useState([]);



  
//   const searchRef = useRef(null);

//   const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
//   const isAdmin = [1, 2, 3].includes(currentUser.role_id);

//   // ================= SOCKET (UNREAD COUNT) =================
//   useEffect(() => {
//     const socket = getSocket();
//     if (!socket) return;


//     // 🔥 get initial online users
// socket.on("online_users", (users) => {
//   setOnlineUsers(users);
// });

// // 🟢 user came online
// socket.on("user_online", ({ userId }) => {
//   // setOnlineUsers((prev) => [...new Set([...prev, userId])]);
//   setOnlineUsers((prev) =>
//   prev.includes(userId) ? prev : [...prev, userId]
// );
// });

// // 🔴 user went offline
// socket.on("user_offline", ({ userId }) => {
//   setOnlineUsers((prev) => prev.filter((id) => id !== userId));
// });





//     const handleRecv = (data) => {
//       // Update user unread
//       setChatUsersList((prev) =>
//         prev.map((u) =>
//           u.id === data.senderId && selectedUser?.id !== data.senderId
//             ? {
//                 ...u,
//                 unread_count: (u.unread_count || 0) + 1,
//                 last_message_time: data.createdAt,
//               }
//             : u
//         )
//       );

//       // Update group unread
//       if (data.groupId) {
//         setGroups((prev) =>
//           prev.map((g) =>
//             g.id === data.groupId && selectedGroup?.id !== data.groupId
//               ? { ...g, unread_count: (g.unread_count || 0) + 1, last_message_time: data.createdAt }
//               : g
//           )
//         );
//       }
//     };

//     socket.on("receive_message", handleRecv);

//     // return () => {
//     //   socket.off("receive_message", handleRecv);
//     // };

//       // ================= CLEANUP =================
//   return () => {
//     socket.off("online_users");
//     socket.off("user_online");
//     socket.off("user_offline");
//     socket.off("receive_message", handleRecv);
//   };
//   }, [selectedUser?.id, selectedGroup?.id]);

//   // ================= FETCH GROUPS =================
//   const fetchGroups = async () => {
//     try {
//       const res = await getChatGroupsApi();
//       if (res?.success) {
//         setGroups(res.groups || []);
//       }
//     } catch (err) {
//       console.error("Failed to fetch groups", err);
//     }
//   };

//   // ================= FETCH USERS =================
//   const fetchChatUsers = async () => {
//     try {
//       const res = await getChatUsersApi();
//       if (res?.success) {
//         setChatUsersList(res.users || res.data || []);
//       }
//     } catch (err) {
//       console.error("Failed to fetch users", err);
//     }
//   };

//   const fetchSearchResults = async (query) => {
//     try {
//       if (!query.trim()) {
//         setSearchResults([]);
//         setIsSearching(false);
//         return;
//       }
//       setIsSearching(true);
//       const res = await getChatUsersApi(query);
//       if (res?.success) {
//         setSearchResults(res.users || res.data || []);
//       }
//     } catch (err) {
//       console.error("Failed to search users", err);
//     }
//   };

//   // Load groups and employees on mount (we only want users with chat history)
//   useEffect(() => {
//     fetchGroups();
//     fetchChatUsers();
    
//     // Fallback: If employees weren't passed, fetch all for the Create Group modal
//     if (!employees || employees.length === 0) {
//       getEmployeesApi().then(res => {
//         if (res?.success) {
//           setAllEmployees(res.data || res.users || []);
//         }
//       });
//     } else {
//       setAllEmployees(employees);
//     }
//   }, [employees]);

//   // Search debounce
//   useEffect(() => {
//     const handler = setTimeout(() => {
//       fetchSearchResults(searchQuery);
//     }, 300);
//     return () => clearTimeout(handler);
//   }, [searchQuery]);

//   // Close dropdown when clicked outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (searchRef.current && !searchRef.current.contains(e.target)) {
//         setIsSearching(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Reset unread count locally on open
//   useEffect(() => {
//     if (selectedUser) {
//       setChatUsersList(prev => prev.map(u => 
//         u.id === selectedUser.id ? { ...u, unread_count: 0 } : u
//       ));
//     }
//   }, [selectedUser]);

//   useEffect(() => {
//     if (selectedGroup) {
//       setGroups(prev => prev.map(g => 
//         g.id === selectedGroup.id ? { ...g, unread_count: 0 } : g
//       ));
//     }
//   }, [selectedGroup]);


//   // ================= COMBINE & SORT =================
//   const combinedChats = [
//     ...groups.map(g => ({ ...g, isGroup: true })),
//     ...chatUsersList.map(u => ({ ...u, isGroup: false }))
//   ].sort((a, b) => {
//     const timeA = new Date(a.last_message_time || a.created_at || 0).getTime();
//     const timeB = new Date(b.last_message_time || b.created_at || 0).getTime();
//     return timeB - timeA;
//   });



//   useEffect(() => {
//     const userId = window.__OPEN_CHAT_USER_ID__;
  
//     if (userId && chatUsersList.length > 0) {
//       const user = chatUsersList.find(u => u.id === userId);
  
//       if (user) {
//         setSelectedUser(user);
  
//         // clear after use
//         window.__OPEN_CHAT_USER_ID__ = null;
//       }
//     }
//   }, [chatUsersList]);

//   return createPortal(
//     <div className="fixed inset-0 z-[9999] flex justify-end">

//       {/* BACKDROP */}
//       <div
//         onClick={onClose}
//         className="absolute inset-0 bg-black/50 backdrop-blur-md"
//       />

//       {/* DRAWER */}
//       <div className="relative w-[420px] max-w-[95%] h-full flex flex-col bg-[#1e1e2d] shadow-2xl border-l border-white/20 text-white">

//         {/* HEADER */}
//         <div className="flex justify-between items-center p-4 border-b border-white/10 bg-gradient-to-r from-[#2d1c6a] to-[#24155a]">
//           <h3 className="text-lg font-semibold tracking-wide ml-2 flex items-center gap-2">
//             Team Chat
//           </h3>

//           <div className="flex items-center gap-3">
//             {isAdmin && (
//               <button
//                 onClick={() => setShowCreateGroup(true)}
//                 title="Create Group"
//                 className="w-8 h-8 rounded-md bg-white/20 hover:bg-white/30 flex items-center justify-center transition border border-white/10"
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
//                   <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
//                   <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
//                 </svg>
//               </button>
//             )}
//             <button
//               onClick={onClose}
//               className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition"
//             >
//               ✕
//             </button>
//           </div>
//         </div>

//         {/* SEARCH BAR */}
//         {!selectedUser && !selectedGroup && (
//           <div className="p-4 border-b border-white/10 bg-black/20 relative z-50">
//             <div className="relative" ref={searchRef}>
//               <input 
//                 type="text" 
//                 placeholder="Search users to start a chat..." 
//                 value={searchQuery}
//                 onFocus={() => setIsSearching(searchQuery.trim().length > 0)}
//                 onChange={(e) => {
//                   setSearchQuery(e.target.value);
//                   setIsSearching(e.target.value.trim().length > 0);
//                 }}
//                 className="w-full bg-white/5 text-white text-sm rounded-lg pl-10 pr-10 py-2.5 outline-none border border-white/10 focus:border-purple-500 placeholder:text-gray-400 transition" 
//               />
//               <svg 
//                 className="absolute left-3 top-2.5 text-gray-400 w-5 h-5 pointer-events-none" 
//                 fill="none" 
//                 stroke="currentColor" 
//                 viewBox="0 0 24 24"
//               >
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//               </svg>

//               {searchQuery && (
//                 <button
//                   onClick={() => {
//                     setSearchQuery("");
//                     setIsSearching(false);
//                     fetchSearchResults(""); 
//                   }}
//                   className="absolute right-3 top-2.5 text-gray-400 hover:text-white transition"
//                 >
//                   ✕
//                 </button>
//               )}

//               {/* DROPDOWN */}
//               {isSearching && (
//                 <div className="absolute top-full left-0 w-full mt-2 bg-[#1e1e2d] border border-white/10 rounded-xl shadow-2xl max-h-64 overflow-y-auto custom-scrollbar z-[10000]">
//                   {searchResults.length === 0 ? (
//                     <div className="p-4 text-center text-gray-400 text-sm">No users found</div>
//                   ) : (
//                     searchResults.map(u => (
//                       <div 
//                         key={u.id}
//                         onClick={() => {
//                           setSelectedUser(u);
//                           setIsSearching(false);
//                           setSearchQuery("");
//                         }}
//                         className="flex items-center gap-3 p-3 hover:bg-white/10 cursor-pointer border-b border-white/5 last:border-0"
//                       >
//                         <div className="w-8 h-8 rounded-full overflow-hidden bg-white/20">
//                           {u.profile_pic ? (
//                             <img src={`${IMAGE_BASE_URL}${u.profile_pic}`} alt="profile" className="w-full h-full object-cover"/>
//                           ) : (
//                             <div className="w-full h-full flex items-center justify-center bg-purple-500 text-white font-semibold text-xs">
//                               {u.first_name?.charAt(0)}
//                             </div>
//                           )}
//                         </div>
//                         <div>
//                           <p className="text-sm font-medium">{u.first_name} {u.last_name}</p>
//                           {/* <p className="text-[10px] text-gray-400">{u.email}</p> */}
//                         </div>
//                       </div>
//                     ))
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {/* BODY */}
//         <div className="flex-1 overflow-y-auto p-2 flex flex-col custom-scrollbar">

//           {selectedUser || selectedGroup ? (
//             <ChatWindow
//               user={selectedUser}
//               group={selectedGroup}
//               currentUser={currentUser}
//               onBack={() => {
//                 setSelectedUser(null);
//                 setSelectedGroup(null);
//                 // Refresh list on back to get updated times/unread
//                 fetchGroups();
//                 fetchChatUsers();
//               }}
//               onInspectGroup={() => setInspectGroup(selectedGroup)}
//               onGroupDeleted={() => {
//                 setSelectedGroup(null);
//                 fetchGroups();
//               }}
//             />
//           ) : (
//             <div className="flex flex-col gap-1 pb-10">
              
//               {combinedChats.map(item => {
//                 if (item.isGroup) {
//                   return (
//                     <div
//                       key={`g_${item.id}`}
//                       onClick={() => setSelectedGroup(item)}
//                       className="flex items-center gap-3 p-3 hover:bg-white/10 rounded-xl cursor-pointer transition mb-1 border border-transparent hover:border-white/5"
//                     >
//                       <div className="w-12 h-12 rounded-full bg-purple-600/50 flex items-center justify-center font-bold text-white shadow-lg overflow-hidden border border-purple-400/30">
//                         {item.name.charAt(0).toUpperCase()}
//                       </div>

//                       <div className="flex-1">
//                         <p className="font-medium text-[15px]">{item.name}</p>
//                         <p className="text-xs text-gray-400 mt-0.5">Group</p>
//                       </div>

//                       {item.unread_count > 0 && (
//                         <div className="bg-red-500 w-5 h-5 flex items-center justify-center text-[10px] font-bold rounded-full text-white shadow">
//                           {item.unread_count}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 } else {
//                   return (
//                     <div
//                       key={`u_${item.id}`}
//                       onClick={() => setSelectedUser(item)}
//                       className="flex items-center gap-3 p-3 hover:bg-white/10 rounded-xl cursor-pointer transition mb-1 border border-transparent hover:border-white/5"
//                     >
//                       {/* <div className="w-12 h-12 rounded-full overflow-hidden bg-white/20 shadow-lg border border-white/10">
//                         {item.profile_pic ? (
//                           <img
//                             src={`${IMAGE_BASE_URL}${item.profile_pic}`}
//                             alt="profile"
//                             className="w-full h-full object-cover"
//                           />
//                         ) : (
//                           <div className="w-full h-full flex items-center justify-center bg-[#2b195c] text-white font-bold opacity-90">
//                             {item.first_name?.charAt(0)}
//                           </div>
//                         )}
//                       </div> */}

// <div className="relative w-12 h-12">
//   <div className="w-12 h-12 rounded-full overflow-hidden bg-white/20">
//     {item.profile_pic ? (
//       <img
//         src={`${IMAGE_BASE_URL}${item.profile_pic}`}
//         alt="profile"
//         className="w-full h-full object-cover"
//       />
//     ) : (
//       <div className="w-full h-full flex items-center justify-center bg-[#2b195c] text-white font-bold">
//         {item.first_name?.charAt(0)}
//       </div>
//     )}
//   </div>

//   {/* 🟢 Teams-style ONLINE DOT */}
//   {onlineUsers.includes(item.id) && (
//     <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white shadow-sm"></span>
//   )}
// </div>

//                       <div className="flex-1">
//                         <p className="font-medium text-[15px]">
//                           {item.first_name} {item.last_name}
//                         </p>
//                         {/* <p className="text-xs text-gray-400 mt-0.5 truncate max-w-[180px]">{item.email}</p> */}
//                       </div>

//                       {item.unread_count > 0 && (
//                         <div className="w-5 h-5 rounded-full bg-red-500 flex items-center justify-center text-[10px] font-bold text-white shadow">
//                           {item.unread_count}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 }
//               })}

//               {combinedChats.length === 0 && (
//                  <p className="text-center text-sm text-gray-400 mt-10">No chats found. Use the search bar above to start a conversation.</p>
//               )}

//             </div>
//           )}
//         </div>

//         {/* MODALS */}
//         {showCreateGroup && (
//           <CreateGroupModal
//             employees={allEmployees}
//             onClose={() => setShowCreateGroup(false)}
//             onGroupCreated={fetchGroups}
//           />
//         )}

//         {inspectGroup && (
//           <GroupMembersModal
//             group={inspectGroup}
//             onClose={() => setInspectGroup(null)}
//             employees={allEmployees}
//             isAdmin={isAdmin}
//           />
//         )}
//       </div>
//     </div>,
//     document.body
//   );
// }